import {
  isValid, isBefore, isEqual, parseISO,
} from 'date-fns'
import { DAY_TIMES } from 'www/vue_components/common/TheFilters/doctors/constants'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

function getValidFilters(filters: Filters) {
  if (filters.patientAge !== undefined && filters.patientAge > 100) {
    delete filters.patientAge
  }

  if (filters.price.from !== undefined && filters.price.from > 999999999) {
    delete filters.price.from
  }

  if (filters.price.to !== undefined && filters.price.to > 999999999) {
    delete filters.price.to
  }

  if (!isValidDateRange(filters.dateRange)) {
    delete filters.dateRange
  }

  if (!isValidTimesOfDay(filters.timesOfDay)) {
    delete filters.timesOfDay
  }

  return filters
}

function isValidDateRange(dateRange: Filters['dateRange']) {
  if (!Array.isArray(dateRange)) {
    return false
  }

  const [startDate, endDate] = dateRange.map(date => parseISO(date))

  if (!isValid(startDate) || !isValid(endDate)) {
    return false
  }

  // Проверяем, что startDate <= endDate
  return isBefore(startDate, endDate) || isEqual(startDate, endDate)
}

function isValidTimesOfDay(timesOfDay: Filters['timesOfDay']) {
  if (!Array.isArray(timesOfDay)) {
    return false
  }

  return timesOfDay.every(time => DAY_TIMES[time])
}

export default getValidFilters
